export default {
  path: '/',
  icon: 'home',
  title: '首页',
  disableAuth: true,
  children: [
    {
      path: 'home',
      icon: 'home',
      title: '首页',
      disableAuth: true,
      fixedTab: true,
      component: 'system/home'
    },
    {
      path: 'refresh',
      disableAuth: true,
      disableTab: true,
      component: 'system/function/refresh'
    },
    {
      path: 'redirect/:route*',
      disableAuth: true,
      disableTab: true,
      component: 'system/function/redirect'
    }
  ]
}
